module.exports = __webpack_public_path__ + "img/1.6a420e07.png";